import { render, staticRenderFns } from "./ButtonsCard.vue?vue&type=template&id=a0f8e1be&scoped=true&"
import script from "./ButtonsCard.vue?vue&type=script&lang=js&"
export * from "./ButtonsCard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsCard.vue?vue&type=style&index=0&id=a0f8e1be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f8e1be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VIcon,VRow,VTooltip})
